import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LinkbarService {
  public linksSet$ = new BehaviorSubject([]);
}
